<div class="card card-activity-feed">
    @if (feedTitle) {
        <div class="card-header">
            <h2 class="card-title">{{ feedTitle }}</h2>
        </div>
    }
    <div class="card-body">
        <div *adaptLoading="!initialDataLoaded"
             class="display-activity-feed-component">
            @if (noActivity) {
                <div [ngClass]="errorMessage ? 'alert alert-danger' : ''">
                    {{ errorMessage || emptyFeedText }}
                </div>
            } @else {
                <ol>
                    @for (activityGroup of activityByDate; track activityGroup) {
                        <li>
                            <adapt-activity-feed-date-group [dateGroup]="activityGroup"></adapt-activity-feed-date-group>
                        </li>
                    }
                </ol>
            }
        </div>
        <ng-container *adaptLoading="loadingMoreActivity">
            @if (!noActivity) {
                <div class="loading-more-activity-date">
                    Showing activity from
                    {{ oldestActivityDate | adaptMoment: "DD MMM" }}
                </div>
            }
        </ng-container>
    </div>
    @if (!noActivity) {
        <div class="card-footer">
            @if (noMoreActivityToLoad) {
                <button disabled>No more activity to load</button>
            } @else {
                <button [disabled]="!initialDataLoaded"
                        (click)="promiseToLoadMoreActivity()">Load more</button>
            }
        </div>
    }
</div>
